export enum ResponseCode {
  COMPLETE,
  COMPLETE_ASYNC,
  BROKER_ERROR,
  INVALID_REQUEST,
  SERVICE_ERROR,
  PARTIAL_COMPLETE,
}

export namespace ResponseCode {
  let elements = [
    ResponseCode.COMPLETE,
    ResponseCode.COMPLETE_ASYNC,
    ResponseCode.BROKER_ERROR,
    ResponseCode.INVALID_REQUEST,
    ResponseCode.SERVICE_ERROR,
    ResponseCode.PARTIAL_COMPLETE,
  ];
  let alias = "com.bcdfx.api.broker.ResponseCode";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
